import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="relative py-16 md:py-20 lg:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            Najczęściej zadawane pytania
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base">
            Odpowiedzi na najważniejsze pytania dotyczące USFans Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <h3 className="font-semibold text-foreground-800 text-sm md:text-base pr-4">
                  {item.question}
                </h3>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-100 rotate-45' : 'bg-background-100'
                }`}>
                  <i className={`ri-add-line text-sm ${openIndex === index ? 'text-primary-600' : 'text-foreground-500'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 md:pb-6' : 'max-h-0'
                }`}
              >
                <p className="px-5 md:px-6 text-foreground-500 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}